import React, { useContext, useEffect } from 'react';
import t from 'react-translate';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { getAiRolePlay } from 'redux/selectors/timeline';

import { openConfirmationDialog } from 'redux/actions/confirmation-dialogs';
import SetUpInstruction from '.';
import useAiRolePlayHelper from '../../hooks/use-ai-role-play-helper';
import EditAiInstructionContext from './context';

const EditInstructionFormModal = (props) => {
  const {
    saveComponent,
    lectureComponent,
  } = props;

  const { forwardOnModalCloseRef, setShowEditAiInstruction } = useContext(EditAiInstructionContext);

  const aiRolePlay = useSelector((state) => getAiRolePlay(state, lectureComponent.aiRolePlay));
  const { updateAiRolePlayValidationSchema } = useAiRolePlayHelper();

  const dispatch = useDispatch();

  const {
    description,
    learnerRole,
    aiCharacterRole,
    aiCharacterName,
    context,
    aiCharacterPersonality,
    aiCharacterObjections,
    aiLearnerGoals,
  } = aiRolePlay || {};

  const defaultValues = {
    learnerRole,
    aiCharacterRole,
    aiCharacterName,
    context,
    aiCharacterPersonality,
    aiCharacterObjections,
    description,
    // first element of learner objectives is set as required
    requiredAiLearnerGoal: aiLearnerGoals[0],

    // for additional learner goals
    aiLearnerGoals: aiLearnerGoals
      .slice(1),
  };

  const methods = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(updateAiRolePlayValidationSchema),
  });

  const { formState } = methods;
  const { isDirty } = formState;

  useEffect(() => {
    if (isDirty) {
      forwardOnModalCloseRef.current = () => {
        dispatch(openConfirmationDialog({
          onConfirm: () => { setShowEditAiInstruction(false); },
          cancelText: t.FORM.CANCEL(),
          confirmText: t.FORM.YES_SURE(),
          title: t.FORM.UNSAVED_CHANGES.CLOSE_WINDOW.TITLE(),
          bodyText: t.FORM.UNSAVED_CHANGES.CLOSE_WINDOW.DESCRIPTION(),
        }));
      };
    } else {
      forwardOnModalCloseRef.current = () => {
        setShowEditAiInstruction(false);
      };
    }
  }, [dispatch, forwardOnModalCloseRef, setShowEditAiInstruction, isDirty]);

  return (
    <FormProvider {...methods}>
      <form>
        <SetUpInstruction
          onSubmit={saveComponent}
          isUpdate
          onCancel={() => setShowEditAiInstruction(false)}
        />
      </form>
    </FormProvider>
  );
};

export default EditInstructionFormModal;
